import React, { Component } from "react";
import "../Css/dumpyarddiv.css";
import "../Css/design-process.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import FigmaMeasureTag from "./FigmaMeasureTag";

const TOTAL_INTENTIONS_GRID_CELLS = 16 * 8;
const DRAW_DIRECTIONS = ["draw-left", "draw-right", "draw-top", "draw-bottom"];

class DumpardDiv extends Component {
  constructor(props) {
    super(props);
    this.state = { gridInView: false };
    this.gridLinesRef = React.createRef();
    // Each cell draws in from a random edge, computed once per mount.
    this.cellDirections = Array.from(
      { length: TOTAL_INTENTIONS_GRID_CELLS },
      () => DRAW_DIRECTIONS[Math.floor(Math.random() * DRAW_DIRECTIONS.length)],
    );
  }

  componentDidMount() {
    if (!this.gridLinesRef.current) return;
    this.gridObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ gridInView: true });
          this.gridObserver.disconnect();
        }
      },
      { threshold: 0.15 },
    );
    this.gridObserver.observe(this.gridLinesRef.current);
  }

  componentWillUnmount() {
    if (this.gridObserver) this.gridObserver.disconnect();
  }

  render() {
    const inceptionDate = new Date("2019-12-15");
    const currentDate = new Date();
    const diffTime = currentDate - inceptionDate;
    const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365.25);
    const experience = diffYears.toFixed(1);

    const totalCells = TOTAL_INTENTIONS_GRID_CELLS;

    return (
      <section className="intentions-section">
        <div
          className={`grid-lines ${this.state.gridInView ? "in-view" : ""}`}
          ref={this.gridLinesRef}
        >
          {Array.from({ length: totalCells }).map((_, i) => (
            <div
              className={`grid-line-cell ${this.cellDirections[i]}`}
              key={i}
              style={{ animationDelay: `${(i % 16) * 0.1}s` }}
            />
          ))}
        </div>

        <div className="intentions-content">
          <div className="intentions-text-cell">
            <span className="aim">AIM &nbsp;✱&nbsp; BELIEFS</span>
            <h1 className="intentions-heading">
              Build the World with{" "}
              <FigmaMeasureTag>
                <span className="accent">Intentions</span>
              </FigmaMeasureTag>
            </h1>
            <div className="intentions-para">
              <p>
                Driven by vision and intention, I focus on purposeful design
                choices that amplify clarity. Each project tells a story of
                contrast, evolution, and the connection between product and
                human experience.
              </p>
              <p>
                I am a firm believer that design is more than just aesthetics.
                It's about solving problems that others don't have; it's about
                creating something durable and functional. This makes the
                difference between good and best-in-class products.
              </p>
            </div>
          </div>

          <div className="stats-grid-cell">
            <div className="stat-card info1">
              <div style={{ display: "flex", flexDirection: "column", }}>
                {" "}
                <img
                  className="stat-icon"
                  src={
                    "https://ik.imagekit.io/harshitsharma/company_logos/exp_hOsmG0Q4i.svg"
                  }
                  alt=""
                />
                <p className="stat-label">Years of Total Experience</p>
              </div>

              <span className="stat-value">{experience}+</span>
            </div>

            <div className="stat-card info2">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <img
                  className="stat-icon"
                  src={
                    "https://ik.imagekit.io/harshitsharma/company_logos/team_Vxm_bJCUH.svg"
                  }
                  alt=""
                />
                <p className="stat-label">Satisfied Client</p>
              </div>

              <span className="stat-value">13+</span>
            </div>

            <div className="stat-card info3">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <img
                  className="stat-icon"
                  src={
                    "https://ik.imagekit.io/harshitsharma/company_logos/cal_wIHahbUwg.svg"
                  }
                  alt=""
                />
                <p className="stat-label">Completed Projects</p>
              </div>

              <span className="stat-value">30+</span>
            </div>

            <div className="stat-card info4">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <img
                  className="stat-icon"
                  src={
                    "https://ik.imagekit.io/harshitsharma/company_logos/crisis_xA05rVQhn.svg"
                  }
                  alt=""
                />
                <p className="stat-label">Days without a creative crisis</p>
              </div>

              <span className="stat-value">0 Days</span>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default DumpardDiv;
